var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNumberIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-solid_1_",
    "data-name": "phone-solid (1)",
    d: "M7.085,1.035a1.713,1.713,0,0,0-2.037-1L1.268,1.07A1.724,1.724,0,0,0,0,2.728,19.25,19.25,0,0,0,19.249,21.977a1.724,1.724,0,0,0,1.659-1.268l1.031-3.781a1.713,1.713,0,0,0-1-2.037l-4.125-1.719a1.713,1.713,0,0,0-1.989.5L13.092,15.79a14.522,14.522,0,0,1-6.9-6.9L8.305,7.154a1.715,1.715,0,0,0,.5-1.989L7.085,1.04Z",
    transform: "translate(0 0.023)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberIcon);
export default __webpack_public_path__ + "static/media/phone-number-icon.6b05ecc266b9b6b8d05271d7b98fd076.svg";
export { ForwardRef as ReactComponent };